import { Autocomplete, Box, Button, Card, Table, Typography } from '@mui/joy'
import React, { useState } from 'react'
import Checkbox from '@mui/material/Checkbox';
import { post, Token } from '../../../../Script/Session';
import { useNavigate } from 'react-router-dom';
function BestTarif({ data }) {
    const [selectedsparte, setselectedsparte] = useState();
    const [selectedsub, setselectedsub] = useState();
    const [subs, setsubs] = useState([]);
    const [subkathdata, setsubkathdata] = useState();
    const navigate = useNavigate();
    const [fragencheck, setfragencheck] = useState(new Map());
    const [allchecked, setallchecked] = useState(false);
    const [ergebnissarten, setergebnissarten] = useState(["PDF", "HTML"]);
    const [selectede, setselectede] = useState();
    const handlekathchange = (newv) => {
        setselectedsparte(newv);
        setsubs(newv.subkaths);
    }
    const handlesubkathchange = (newv) => {
        setselectedsub(newv);
    }
    function setsub() {
        if (!selectedsub) {
            return;
        }
        let body = {};
        body.token = Token.get();
        body.action = "get_tarifs";
        body.targetsubkath = selectedsub.id;
        let response = post(body, "/vergleichen");
        if (response == "LOGOUT") {
            navigate("/");
        }
        let a = new Map(fragencheck);
        const prased = JSON.parse(response);
        setsubkathdata(prased);
        prased.fragen
            .slice()
            .sort((a, b) => a.order - b.order)
            .map((item, index) => {
                const keys = Object.keys(item).filter(k => k !== "order");
                const name = keys[0] || "Unbenannt";
                item[name]
                    .slice()
                    .sort((a, b) => a.order - b.order)
                    .map((frage, idx) => {

                        a.set(frage.name, false);
                        console.log("set " + frage.name);

                    })
            })
        setfragencheck(a);
    }
    function getbesttarif() {
        if (!selectede) {
            return;
        }
        let body = {};
        body.token = Token.get();
        body.action = "best";
        let n = [];
        fragencheck.forEach((value, key) => {
            if (value) {
                n.push(key);
            }
        });
        body.fragenlist = n;
        body.targetsubkath = selectedsub.id;
        let response = post(body, "/vergleichen");
        if (response == "LOGOUT") {
            navigate("/");
            return;
        }
        console.log(response);
        const key = "get_best_ergebniss_data";

        // Save all the data you want to pass
        localStorage.setItem(key, JSON.stringify({
            response,
            selectede,
            fragen: subkathdata.fragen,
            subkathdata,
            n
        }));
        navigate("/get_best_ergebniss");
    }


    return (
        <Box sx={{ width: "100%", height: "100%", display: "flex", flexDirection: "row" }}>
            <Box sx={{ display: "flex", flexDirection: "column", width: "50%" }}>
                <Card variant='soft' sx={{ width: "95%" }}>
                    <Typography level="title-md">1.Tarif wählen</Typography>
                    <Autocomplete placeholder='Sparte' value={selectedsparte} onChange={(e, newv) => handlekathchange(newv)} options={data.result} getOptionLabel={(i) => i.name} />
                    <Autocomplete placeholder='Untersparte' value={selectedsub} onChange={(e, newv) => handlesubkathchange(newv)} options={subs} getOptionLabel={(i) => i.name} />
                    <Button onClick={() => setsub()} sx={{ width: "15%" }}>
                        Setzen
                    </Button>
                </Card>
                <Card variant='soft' sx={{ width: "95%", mt: 2 }} >
                    <Box>
                        <Typography level="title-md">3.Ergebniss festlegen</Typography>
                        <Typography>Legen sie fest in welcher form ihr Ergebniss angezeigt wird</Typography>
                    </Box>
                    <Autocomplete options={ergebnissarten} value={selectede} onChange={(e, newv) => setselectede(newv)} />
                    <Button onClick={
                        () => getbesttarif()
                    }>Ergebniss anzeigen</Button>
                </Card>
            </Box>
            <Box sx={{ width: "50%", overflowY: "auto", height: "100%" }}>
                <Card variant='soft' sx={{ height: "96%" }}>
                    <Box>
                        <Typography level="title-md">2.Bewertung wählen</Typography>
                        <Typography>Wählen sie die Fragen aus die sie für ihr Ergebniss berücksichtigen wollen</Typography>
                        <Typography>Wenn sie alle Fragen berücksichtigen wollen setzen sie den Haken bei alle</Typography>
                    </Box>
                    <Table borderAxis="both" sx={{
                        bgcolor: "white",
                        '& td': {
                            whiteSpace: 'normal',
                            wordBreak: 'break-word',
                             
                        },
                    }}>
                    <thead>
                        <tr>
                            <th>Frage</th>
                            <th>Ausgewählt</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr key={"all"}>
                            <td>Alle Auswählen</td>
                            <td>
                                <Checkbox value={allchecked} onChange={() => {
                                    const updatedMap = new Map(
                                        Array.from(fragencheck.entries()).map(([key, _]) => [key, !allchecked])
                                    );
                                    setfragencheck(updatedMap);
                                    setallchecked(!allchecked);
                                }} />
                            </td>
                        </tr>
                        {Array.isArray(subkathdata?.fragen) &&
                            subkathdata?.fragen
                                .slice()
                                .sort((a, b) => a.order - b.order)
                                .map((item, index) => {
                                    const keys = Object.keys(item).filter(k => k !== "order");
                                    const name = keys[0] || "Unbenannt";
                                    return (
                                        <React.Fragment key={`${index}-${name}`}>
                                            <tr>
                                                <td colSpan={1} style={{ fontWeight: 'bold' }}>{name}</td>
                                                <td />
                                            </tr>
                                            {Array.isArray(item[name]) &&
                                                item[name]
                                                    .slice()
                                                    .sort((a, b) => a.order - b.order)
                                                    .map((frage, idx) => (
                                                        <tr key={`${index}-${idx}`}>
                                                            <td>{frage.name}</td>
                                                            <td> <Checkbox checked={fragencheck.get(frage.name)} onChange={() => {
                                                                let a = new Map(fragencheck);
                                                                a.set(frage.name, !a.get(frage.name));
                                                                setfragencheck(a);
                                                            }} /></td>
                                                        </tr>
                                                    ))}
                                        </React.Fragment>
                                    );
                                })}

                    </tbody>
                </Table>

            </Card>


        </Box>




        </Box >
    )
}

export default BestTarif
